import {useConfigContext} from "@/ConfigProvider";

export const useTranslations = () => {
    const { tc } = useConfigContext();
    return tc;
};